import { SxProps, Theme } from '@mui/material';

export const ViewWrapperPaperStyles: SxProps<Theme> = {
  minHeight: '100%',
  width: '100%',
};
